import { render, staticRenderFns } from "./assessmentProjectHtmlDom.vue?vue&type=template&id=12fbca4f&"
import script from "./assessmentProjectHtmlDom.vue?vue&type=script&lang=js&"
export * from "./assessmentProjectHtmlDom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports